import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { PageInfoService, PageLink } from '@metronic/layout';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { IListRetailer } from '@models/retailer.model';
import { UtilitiesService } from '@services/utilities.service';
import { FormGroup } from '@angular/forms';
import { TableColumn } from '@shared/interface/table.interface';
import { BaseDatasource } from '@shared/base/base.datasource';
import { BehaviorSubject } from 'rxjs';
import { API } from '@config/constants/api.constant';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { FilterService } from '@services/filter.service';
import { RetailerService } from '../retailer.service';
import { IDataRetailerList } from '../retailers.interface';

@Component({
  selector: 'app-reject',
  templateUrl: './reject.component.html',
  styleUrls: ['./reject.component.scss'],
})
export class RejectComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) matSort: MatSort;
  @Output() totalCount = new EventEmitter();
  STRING_CONSTANTS = STRING_CONSTANTS;
  iconNone = STRING_CONSTANTS.ICON.IC_RETAIL_NONE;
  isLoading = false;
  // table
  baseTable: BaseTableService<IListRetailer> = this.base;
  tableColumns: TableColumn[];
  displayedColumns: string[];
  baseDatasourcePending: BaseDatasource<IListRetailer>;
  string_filter?: string;
  checkActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isOpenFilter: boolean = false;
  isActiveFilter: boolean = false;
  filterForm: FormGroup;
  privilageDetailReject: boolean;

  dataList: IDataRetailerList;
  links: Array<PageLink> = [
    {
      title: 'Retailer',
      path: '',
      isActive: false,
    },
    {
      title: '',
      path: '',
      isActive: false,
      isSeparator: true,
    },
    {
      title: 'Ditolak',
      path: '',
      isActive: true,
    },
  ];

  constructor(
    private pageInfoService: PageInfoService,
    private base: BaseTableService<IListRetailer>,
    public utilities: UtilitiesService,
    private rolePrivilegeService: RolePrivilegeService,
    public filterService: FilterService,
    public retailerService: RetailerService
  ) {}

  ngOnInit() {
    this.privilageDetailReject = this.rolePrivilegeService.checkPrivilege('RETAILER', 'LIST_RETAILER_DITOLAK', 'CTA_VIEW_DETAIL');
    this.pageInfoService.updateBreadcrumbs(this.links);
    this.setTableData();
    this.dataList = {
      status: 'reject',
      tab: 'registration',
      view: 'default',
    };
  }

  setTableData() {
    this.tableColumns = this.retailerService.getRejectTableColumns();
    this.tableColumns = this.utilities.privilegeTableColumns(this.privilageDetailReject, this.tableColumns);
  }

  handleCount(count: number) {
    this.pageInfoService.updateTitle(`Retailer Ditolak (${count})`);
    this.pageInfoService.updateBreadcrumbs(this.links);
  }

  protected readonly API = API;
}
